<template>
  <div class="row">
    <div class="col-md-12 text-left">
      <modal :show.sync="ModalOrder">
        <template slot="header">
          <h5 class="modal-title sub_title" id="exampleModalLabel">Crear Order</h5>
        </template>
        <div class="row">
          <div class="col-7 row">
            <div class="col-7">
              <label class="typo__label">Pedido para:</label>
              <multiselect v-model="selectuser"
                           :options="users"
                           :custom-label="customLabel"
                           :searchable="true"
                           :close-on-select="true"
                           track-by="user_id" label="last_name"
                           placeholder="Seleccionar uno">
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.name + ' ' + option.last_name }}</strong>
                </template>
              </multiselect>
            </div>
            <div class="col-5">
              <div v-if="restaurant != undefined && restaurant.length>0">
                <label class="typo__label">Restaurante</label>
                <multiselect v-model="rest"
                             :options="restaurant"
                             :searchable="true"
                             :close-on-select="true"
                             track-by="restaurant_id" label="name"
                             placeholder="Seleccionar">
                </multiselect>
              </div>
            </div>
            <div class="col-12">
              <label class="typo__label">Producto</label>
              <multiselect v-model="sku"
                           deselect-label="No se puede remover este valor"
                           track-by="sku_product_id"
                           label="name"
                           :custom-label="customLabelsku"
                           :close-on-select="true"
                           placeholder="Seleccionar"
                           :options="product_sku"
                           :searchable="true"
                           :allow-empty="false">
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.name }}</strong> En Stock <strong>
                  {{ option.stock_quantity }}</strong>
                  <span
                      v-if="option.unit_price > 0"> Precio Unidad  <strong>${{
                      formatPrice(option.unit_price)
                    }}</strong> </span>
                  Precio kilo <strong> ${{ formatPrice(option.price) }}</strong>

                </template>
              </multiselect>
            </div>
            <div class="col-6" v-if="unidad != undefined && unidad.length>0">

              <label class="typo__label">Unidad de medida</label>
              <multiselect v-model="uni" :options="unidad" :searchable="false"
                           :close-on-select="true" :show-labels="false"
                           track-by="unit_type_id" label="unit_name"
                           placeholder="Seleccionar"></multiselect>


            </div>
            <div class="col-6" v-if="unidad != undefined && unidad.length>0">
              <label for="cantidad">Cantidad</label>

              <input
                  id="cantidad"
                  v-model="order_product.quantity"
                  type="number"
                  min="1"
                  class="form-control"
                  placeholder="Cantidad"
                  v-on:input="removeLeadingZeros"
              >
            </div>
            <div class="col-6" v-if="unidad != undefined && unidad.length>0">
              <label for="nota">Nota</label>

              <input
                  id="nota"
                  v-model="order_product.nota"
                  type="text"
                  class="form-control"
              >
            </div>
            <div class="col-6" v-if="unidad != undefined && unidad.length>0">
              <label>Agregar a orden</label>
              <br>
              <base-button size="sm" type="default" outline @click="AddOrderProduct()">
                +
              </base-button>
            </div>
            <div class="col-4">
              <label for="shipping_amount">Valor envio</label>
              <input
                  id="shipping_amount"
                  v-model="order.shipping_amount"
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="Valor envio"
              >
            </div>
          </div>
          <div class="col-5">
            <div class="table-responsive table-flush" style="max-height: 300px">
              <table class="table align-items-center table-dark">
                <thead>
                <th>Producto</th>
                <th>Cantidad</th>
                <th>IVA</th>
                <th>Total</th>
                <th>Nota</th>
                <th></th>
                </thead>
                <tbody v-if="order_product_Sku">
                <tr v-for="(row, index) in order_product_Sku" :key="index">
                  <td>
                    {{ row.name }}
                  </td>
                  <td>
                    {{ row.quantity }}
                  </td>
                  <td>
                    ${{ formatPrice(row.tax_value) }}
                  </td>
                  <td>
                    ${{ formatPrice(row.total) }}
                  </td>
                  <td>
                    {{ row.nota }}
                  </td>
                  <td>
                    <base-button size="sm" type="danger"
                                 @click="removeitem(index,row.total,row.tax_value)"
                                 icon="ni ni-fat-remove"></base-button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div>
              <label>Sub Total: $</label>
              <span>
                                {{ formatPrice(order.total_sale) }}
                            </span>
              <br>
              <label>Total a pagar: $</label>
              <span>
                                {{ formatPrice(order.tax_amount + order.total_sale + parseInt(order.shipping_amount)) }}
                            </span>

            </div>
          </div>


        </div>
        <br>
        <span><strong>Datos de entrega</strong></span>
        <br>
        <div class="row">

          <div class="col-4">
            <label>Dia de entrega</label>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <flat-picker slot-scope="{focus, blur}"
                           @on-open="focus"
                           @on-close="blur"
                           :config="{allowInput: true}"
                           class="form-control datepicker"
                           v-model="shipped_date">
              </flat-picker>
            </base-input>
          </div>
          <div class="col-4">
            <label for="city">Ciudad</label>
            <input
                id="city"
                v-model="city"
                type="text"
                class="form-control"
                placeholder="Ciudad"
            >
          </div>
          <div class="col-4">
            <label for="neighborhood">Barrio</label>

            <input
                id="neighborhood"
                v-model="neighborhood"
                type="text"
                class="form-control"
                placeholder="Barrio"
            >

          </div>

          <div class="col-4">
            <label for="address">Dirección</label>
            <input
                id="address"
                v-model="address"
                type="text"
                class="form-control"
                placeholder="Direccion"
            >

          </div>
          <div class="col-4">
            <label>Telefono</label>
            <input
                id="phone"
                v-model="phone"
                type="number"
                min="0"
                class="form-control"
                placeholder="Telefono"
            >
          </div>
          <div class="col-4">
            <label for="observation">Referencia</label>
            <textarea v-model="observation" class="form-control" id="observation" rows="1"
                      placeholder="Escribe un punto de referencia"></textarea>
          </div>
          <div class="col-12 ">
            <br>
            <span><strong>Quien recibe el pedido?</strong></span>
          </div>
          <div class="radio-default-acre">
            <PrettyRadio name="order_status" v-model="deliver_to" value="Cocina">Cocina</PrettyRadio>
            <PrettyRadio name="order_status" v-model="deliver_to" value="Barra">Barra</PrettyRadio>
            <PrettyRadio name="order_status" v-model="deliver_to" value="Bodega">Bodega</PrettyRadio>
            <PrettyRadio name="order_status" v-model="deliver_to" value="Personal">Personal</PrettyRadio>
          </div>

        </div>
        <template slot="footer">
          <base-button :disabled="btn_create" @click="create" class="btn_submit">Agregar</base-button>
          <base-alert type="danger" v-if="error">
            <strong>{{ error }}</strong>
          </base-alert>
        </template>
        <div class="row">
          <div class="col-12">
            <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                           label="Guardando"></base-progress>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>

import {bus} from './bus-order'
import _ from "lodash";
import {order_service} from '../../services/order/OrderService'
import swal from 'sweetalert';
import PrettyRadio from 'pretty-checkbox-vue/radio';

export default {
  name: "CreateOrder",
  components: {PrettyRadio},
  data() {
    return {
      user_session: [],
      progress: 0,
      btn_create: false,
      error: '',
      rest: [],
      shipped_date: '',
      neighborhood: ' ',
      city: '',
      address: '',
      phone: 0,
      observation: ' ',
      deliver_to: 'Cocina',
      users: [],
      restaurant: [],
      selectuser: [],
      uni: null,
      ModalOrder: false,
      sku: [],
      unidad: [],
      product_sku: [],
      order_product: {
        quantity: 1,
        nota: ''
      },
      orders_products: [],
      order: {
        order_date: '',
        tax_amount: 0,
        shipped_date: '',
        shipping_amount: 0,
        total_sale: 0,
        shipping: [],
        ship: "[]",
        User: [],
        user_id: 0,
        OrderStatus: {
          order_status_id: 5
        },
        Paymethod: [
          {
            paymethod_id: 2
          }
        ],

      },
      order_product_Sku: [],
      restaurants: [],

    }
  },
  watch: {
    'sku': function () {

      if (this.sku.unit != undefined) {
        this.unidad = JSON.parse(this.sku.unit)
      }
    },
    'selectuser': function () {
      if (this.selectuser) {

        if (this.selectuser.restaurant.length > 0) {
          this.restaurant = this.selectuser.restaurant
        } else {
          this.order.OrderStatus.order_status_id = 6
          this.order.User.push({"user_id": this.selectuser.dealer}, {"user_id": this.selectuser.user_id})
          order_service.GetAllProductSku(this.selectuser.Discounts.discounts_id)
        }
      }
    },
    'rest': function () {

      const restafilter = _.filter(this.restaurants, (c) => {
        if (c.restaurant_id === this.rest.restaurant_id) {
          return c
        }
      })
      const users = restafilter[0].user
      if (users.length) {
        this.order.OrderStatus.order_status_id = 6
        this.order.User.push({"user_id": this.selectuser.user_id})
        for (const i in users) {
          if (users[i].user_type_id.user_type_id === 4) {
            this.order.User.push({"user_id": users[i].user_id})
          }
        }
      }

      for (const prop in restafilter) {

        this.address = restafilter[prop].address
        this.city = restafilter[prop].City.name
        this.phone = restafilter[prop].phone
        order_service.GetAllProductSku(restafilter[prop].Discounts.discounts_id)
      }

    }

  },
  methods: {
    removeLeadingZeros() {

      const inputValue = this.order_product.quantity;


      // Verificar que el valor de entrada es un número
      if (!isNaN(inputValue)) {
        // Comprobar si el valor de entrada es un número decimal
        const isDecimal = inputValue.includes(".");

        // Si el valor de entrada es un número decimal, convertirlo en un número con parseFloat
        if (isDecimal) {
          //this.order_product.quantity = inputValue;
          return;
        }

        // Si el valor de entrada es un número entero, utilizar una expresión regular para eliminar los ceros a la izquierda
        if (inputValue.length > 1) {
          const newValue = inputValue.replace(/^0+/, '');
          this.order_product.quantity = newValue;
        }

      } else {
        // Si el valor de entrada no es un número, vaciar el campo
        this.order_product.quantity = "";
      }
    },
    customLabelsku({name}) {
      return `${name} `
    },
    customLabel({name, last_name}) {
      return `${name} ${last_name}`
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    ShowOrder() {
      this.ModalOrder = !this.ModalOrder
    },
    AddOrderProduct() {
      this.error = ''
      var valproduct = 0
      var price = 0
      var tax = 0

      if (this.uni.shotname === 'Uni') {
        valproduct = this.order_product.quantity * this.sku.unit_price
        price = this.sku.unit_price
      }
      if (this.uni.shotname === 'GR') {
        valproduct = this.order_product.quantity * (this.sku.price / 1000)
        price = this.sku.price / 1000
      }
      if (this.uni.shotname === 'KL') {
        valproduct = this.order_product.quantity * this.sku.price
        price = this.sku.price
      }
      tax = (valproduct * this.sku.tax) / 100
      this.order.total_sale = this.order.total_sale + valproduct
      this.order.tax_amount = this.order.tax_amount + tax

      this.order_product_Sku.push({
        'product_id': this.sku.product_id,
        'sku': this.sku.sku,
        'name': this.sku.name,
        'quantity': this.order_product.quantity,
        'price': price,
        'tax_product': this.sku.tax,
        'tax_value': (valproduct * this.sku.tax) / 100,
        'total': valproduct,
        'subtotal': valproduct + tax,
        "unit": this.uni.shotname,
        "nota": this.order_product.nota,
        "details": ""
      })
      //console.log(this.order_product_Sku)
      this.sku = []
      this.unidad = []
      this.uni = []
      this.order_product.quantity = 0
      this.order_product.nota = ''
      //console.log( this.order_product_Sku)
    },
    removeitem(x, valtotalitem, tax_value) {
      this.order_product_Sku.splice(x, 1)
      this.order.total_sale = this.order.total_sale - valtotalitem
      this.order.tax_amount = this.order.tax_amount - tax_value
    },
    create() {

      if (this.order_product_Sku.length > 0) {
        this.progress = 50
        this.btn_create = true
        var f = new Date()
        let day = f.getDate()
        let month = f.getMonth() + 1
        let year = f.getFullYear()

        if (month < 10) {

          this.order.order_date = `${year}-0${month}-${day}`
        } else {
          this.order.order_date = `${year}-${month}-${day}`

        }
        //console.log(this.selectuser.user_id)
        this.order.shipped_date = this.shipped_date
        //const user = JSON.parse(sessionStorage.getItem('user'))
        //this.order.User.push({"user_id": this.selectuser.user_id})
        if (this.rest.restaurant_id > 0) {
          this.order.Restaurant = {'restaurant_id': this.rest.restaurant_id}
        }
        this.order.shipping_amount = parseInt(this.order.shipping_amount)
        this.order.shipping.push({
          'address': this.address,
          'phone': this.phone,
          'observation': this.observation,
          'deliver_to': this.deliver_to,
          'neighborhood': this.neighborhood,
          'city': this.city
        })
        this.order.user_id = this.user_session.user_id
        this.order.orderproduct = this.order_product_Sku
        this.order.shipping = JSON.stringify(this.order.shipping)
        //console.log(this.order)
        order_service.CreateOrder(this.order)

      } else {
        this.error = 'Debe agregar peoductos a la orden'
      }
    },
    ResponseCreateOrderProduct(response) {
      if (response.statusText === 'Created') {
        this.progress = 100
        this.ModalOrder = false
        this.cleandatafull()
        swal({
          icon: "success",
          text: "Se Ha Creado La Orden " + response.data.order_id,
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        this.ModalOrder = false
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Fue Posible Crear La Orden",
          button: "Aceptar"
        })
      }

    },
    cleandatafull() {
      //this.selectuser = []
      this.sku = []
      this.unidad = []
      this.uni = []
      this.rest = []
      this.progress = 0
      this.btn_create = false
      this.order_product_Sku = []
      this.order_product.quantity = 0
      this.shipped_date = ''
      this.neighborhood = ' '
      this.city = ''
      this.address = ''
      this.phone = 0
      this.observation = ' '
      this.deliver_to = 'Cocina'
      this.error = ''
      this.order = {
        order_date: '',
        tax_amount: 0,
        shipped_date: '',
        shipping_amount: 0,
        total_sale: 0,
        shipping: [],
        ship: "[]",
        User: [],
        user_id: 0,
        OrderStatus: {
          order_status_id: 1
        },
        Paymethod: [
          {
            paymethod_id: 2
          }
        ],

      }

    }
  },
  created() {
    this.user_session = JSON.parse(sessionStorage.getItem('user'))
    bus.$on('ShowOrder', () => {
      this.ShowOrder()
    })
    bus.$on('ShowOrderReorder', (data) => {
      this.order = data
      //console.log(order)
      //console.log(data)
      this.order_product_Sku = data.orderproduct
      this.ShowOrder()
    })
    bus.$on('GetAllProductSku', (response) => {
      this.product_sku = response

    })
    bus.$on('GetAllUser', (response) => {
      this.users = response
      //console.log('users')
      //console.log(this.users)

    })
    bus.$on('GetAllRestaurant', (response) => {
      this.restaurants = response
      //console.log('rest')
      //console.log(this.restaurants)
    })
    bus.$on('ResponseCreateOrder', (response) => {
      order_service.GetAllOrder()
      this.ResponseCreateOrderProduct(response)
    })
    bus.$on('ResponseCreateOrderProduct', (response) => {
      this.ResponseCreateOrderProduct(response)
    })

  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
@media screen and (min-width: 300px) and (max-width: 1001px) {
  .modal-body > div.row > div {
    flex: 0 0 100%;
    max-width: 100%;
    margin: 0 auto 10px;
    display: block;
  }

  .modal-body > div.row > div.radio-default-acre {
    display: flex;
    flex-wrap: wrap;
  }

  .modal-body > div.row > div > div {
    width: 100%;
    margin: 0 auto 10px;
    flex: 0 0 100%;
    max-width: 100%;
  }

  .modal-body > div.row > div.radio-default-acre > div {
    width: 50%;
    margin: 0 auto 10px;
    flex: 0 0 50%;
    max-width: 50%;
    position: relative;
    height: 4em;
    text-align: center;
  }
}
</style>
